import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';


import './styles.css';

import { Grid, SnackbarContent } from '@mui/material';

//estilo
const classes = {
  root: {
    width: '100%'
  },

  rootCidadao: {
    width: '100%'
  },

  area: {
    width: '100%',
  },

  /* Estilização do conteúdo dentro do container */
  paper: {
    padding: 16,
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'row',
    width: '100%',
    backgroundColor: '#F5F5F5',
  },

  textTitle: {
    margin: 8,
    color: '#41414d',
    fontWeight: 600,
  },

  textDescription: {
    padding: 10,
    backgroundColor: '#FFFBE8',
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%',
    fontFamily: 'Rawline',
    marginBottom: 20
  },

  comment: {
    padding: 10,
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%',
    fontFamily: 'Rawline',
    marginBottom: 20
  },

  areaDescription: {
    margin: 1,
  },
  userComment: {
    color: '#41414d',
    fontSize: 14,
  },

  textComment: {
    marginTop: 1,
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: 1
  },

  textDelete: {
    marginTop: 2,
    color: 'rgba(245, 0, 87, 0.55)',

  },

  buttonSubmit: {
    backgroundColor: '#1551B3',
    color: '#fff',
    borderRadius: '20px',
    height: '45px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop: '17px',
    minWidth: '220px'
  },

  attachButton: {
    backgroundColor: '#1551B3',
    color: '#fff',
    borderRadius: '20px',
    height: '45px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop: '17px'
  },

  downloadButton: {
    borderRadius: '50%',
    backgroundColor: '#1551B3',
    color: '#fff',
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }

};

export default function ShowFeedback({ feedback }) {
 


  return (
    <>
      <Paper style={classes.paper} elevation={2}>
        <div style={classes.area} >
          <Typography
            variant="h6"
            align="left"
            style={{
              color: '#103168',
              fontWeight: 600,
              textAlign: 'center',
              marginBottom: 20
            }}
          >
            Feedback do usuário
          </Typography>

          <Typography variant="body2" align="justify" style={classes.textDescription}>
            Abaixo é possível visualizar o feedback do usuário.

          </Typography>

          <div style={classes.root}>
            <SnackbarContent
              sx={{
                width: '100%', marginTop: '10px', backgroundColor: 'white', boxShadow: 'none',
                '.MuiSnackbarContent-message': {
                  width: '100%'
                }
              }}
              message={
                <Grid
                  style={{ width: '100%' }}
                  container
                  justifyContent={'space-between'}
                >
                  <Grid item >
                  
                    <Typography variant="body2" align="justify" paragraph={true} style={classes.comment}>
                      <span>
                        {feedback}
                      </span>
                    </Typography>
                  </Grid>

                </Grid>
              }
            />
          </div>

        </div >
      </Paper >
    </>
  );
}


